<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{ $t("tit.location.report") }}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/master"><span>{{$t('tlt.administration')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/master/location"><span>{{$t('tlt.location')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/master/location/report/synchronous"><span>{{$t('tlt.location.report.synchronous')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-primary" v-on:click="generateReport({'type':'synchronous', 'reportType':reportType})">
                        <i class="fa fa-fw fa-lg fa-plus"></i>
                        <span class="text">{{ $t("btn.basic.generate") }}</span>
                    </button>
                </div>
            </div>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div
                        id="collapseOne"
                        class="collapse show "
                        aria-labelledby="headingOne"
                        data-parent="#accordionFilter"
                        >
                        <div class="card-body">
                            <form class="row">
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.code") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="codeFilter"/>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.name") }} :
                                    </label>
                                    <input class="form-control" type="text" v-model="locNameFilter"/>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.type") }} :
                                    </label>
                                    <select class="form-control" v-model="locTypeFilter">
                                        <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                        <option value="E">{{ $t("lbl.location.enterprise") }}</option>
                                        <option value="S">{{ $t("lbl.location.site") }}</option>  
                                        <option value="A">{{ $t("lbl.location.area") }}</option>                                        
                                        <option value="W">{{ $t("lbl.location.workCenter") }}</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.active") }}:
                                    </label>
                                    <select class="form-control"  v-model="activeFilter">
                                        <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                        <option value="true">Yes</option>
                                        <option value="false">No</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.type") }}:
                                    </label>
                                    <select class="form-control"  v-model="reportType">
                                        <option value="PDF">PDF</option>
                                        <option value="XLSX">XLS</option>
                                    </select>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import {  mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';
import { filterFields}  from "@/model/master/Location";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
    getterType: 'location/getField',
    mutationType: 'location/updateField',
  });

export default {
  name: "locationReportSyn",
  data () {
    return {
      reportType: "PDF"
    }
  },
  computed: {
        // generate and add getters and setters using the filter names defined in
        // entity model
        ...mapFields(filterFields),
  },
  methods: {
    ...mapActions("report", ["generateReport"])
  }
};
</script>
